import React, { useCallback, useRef, useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  IconButton,
  Box,
  Stack,
  SvgIcon,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import { ReactComponent as CalculatorIcon } from "../../../../../assets/icons/calculator.svg";

import "./CalculatorWrapper.scss";
import Calculator from "./Calculator";

const STORAGE_KEY = "dstl_calc_history";
const MAX_HISTORY = 80;

// Simple tiny component for the left column list
function HistoryPanel({ items, onPick, onClear }) {
  return (
    <aside className="history-panel">
      <SvgIcon component={CalculatorIcon} inheritViewBox />
      <header className="history-header">
        <h3 className="title">Calculator history</h3>
      </header>

      <div className="history-list">
        {items.length === 0 ? (
          <p className="muted">No history yet.</p>
        ) : (
          items.map((h) => (
            <div
              key={h.id}
              className="history-item"
              onClick={() => onPick(h)}
              title="Replay this on calculator"
            >
              <code className="expr">{h.exp}</code>
              <span className="eq">=</span>
              <span className="val">{h.result}</span>
            </div>
          ))
        )}
      </div>

      {/* <div className="history-actions">
        <Button variant="outlined" size="small" onClick={onClear}>
          Clear history
        </Button>
      </div> */}
    </aside>
  );
}

const CalculatorWrapper = ({ open, onClose, level }) => {
  const [history, setHistory] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY + level) || "[]");
    } catch {
      return [];
    }
  });

  const calcRef = useRef(null);

  const persist = useCallback((next) => {
    localStorage.setItem(STORAGE_KEY + level, JSON.stringify(next));
  }, []);

  const addHistory = useCallback(
    (entry) => {
      // entry: { id, exp(display), engine, result }
      setHistory((prev) => {
        const next = [entry, ...prev].slice(0, MAX_HISTORY);
        persist(next);
        return next;
      });
    },
    [persist]
  );

  const handlePick = useCallback((item) => {
    // Load the exact expression the user had (engine + display)
    calcRef.current?.load({
      display: item.exp,
      engine: item.engine,
    });
  }, []);

  const handleClear = useCallback(() => {
    setHistory([]);
    localStorage.removeItem(STORAGE_KEY + level);
  }, []);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      classes={{ paper: "calculator-popup" }}
      maxWidth="lg"
      disableEnforceFocus
      slotProps={{
        backdrop: { className: "custom-backdrop-calculator" },
      }}
    >
      <Box>
        <DialogActions className="calculator-actions">
          <IconButton className="close-button" onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </DialogActions>

        <DialogContent dividers className="calculator-content">
          <div className="calc-layout">
            <HistoryPanel
              items={history}
              onPick={handlePick}
              onClear={handleClear}
            />
            <section className="calc-pane">
              <Stack justifyContent="center" alignItems="center">
                <Calculator ref={calcRef} onEvaluate={addHistory} />
              </Stack>
            </section>
          </div>
        </DialogContent>
      </Box>
    </Dialog>
  );
};

export default CalculatorWrapper;
